import React__default from 'react';
import { useLoadingContext } from './context.es.js';
import { LazyImage } from '../LazyImage/LazyImage.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Loading = ({
  children,
  style,
  isLoading = false,
  size = 80,
  roundColor = "primary",
  className
}) => {
  const { logo } = useLoadingContext();
  const inline = !children;
  const Outermost = inline ? React__default.Fragment : ContainerLoadingWrapper;
  style = style || {};
  style = __spreadValues(__spreadValues({}, style), inline ? {} : { top: 0, left: 0, position: "fixed", zIndex: 9999 });
  return /* @__PURE__ */ React__default.createElement(Outermost, null, isLoading && /* @__PURE__ */ React__default.createElement(LoadingContainer, {
    style,
    className
  }, /* @__PURE__ */ React__default.createElement(Wrapper, {
    size
  }, logo && /* @__PURE__ */ React__default.createElement(LazyImage, {
    width: size / 2,
    height: size / 2,
    src: logo,
    contain: true
  }), /* @__PURE__ */ React__default.createElement(Spinner, {
    roundColor,
    size
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "teko-spinner"
  })))), children && /* @__PURE__ */ React__default.createElement(Container, {
    className: isLoading ? "loading-blur" : ""
  }, children));
};
const ContainerLoadingWrapper = styled.div`
  position: relative;
`;
const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
`;
const Container = styled.div`
  position: relative;
  transition: opacity 0.3s;
  &.loading-blur {
    clear: both;
    opacity: 0.5;
    user-select: none;
    pointer-events: none;
  }
`;
const Wrapper = styled.div(({ size }) => `
  width: ${size}px;
  height: ${size}px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
`);
const Spinner = styled.div(({ size, roundColor, theme }) => {
  var _a;
  return `
  background: none;
  position: absolute;
  @keyframes teko-spinner {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .teko-spinner {    
    margin: auto;
    animation: teko-spinner 1s linear infinite;
    width: ${size * 0.95}px;
    height: ${size * 0.95}px;
    border-radius: 50%;
    box-shadow: 0 2px 0 0 ${((_a = theme.colors) == null ? void 0 : _a[roundColor]) || roundColor};
    box-sizing: content-box;
  }
`;
});

export { Loading };
